import Province from './Province'
import Candidate from './Candidate'

export default class Riding {
  private _id: number
  // private ecName: string
  private enName: string
  private frName: string
  public province: Province
  protected candidatesDict: { [partyCode: string]: Candidate }

  public constructor(id: number, ecName: string, province: Province) {
    this._id = id
    const niceName = ecName.replace(/--/g, '—') // Replace -- with mdash
    this.enName = niceName.includes('/') ? niceName.split('/')[0] : niceName
    this.frName = niceName.includes('/') ? niceName.split('/')[1] : niceName
    this.province = province
    this.candidatesDict = {}
    province.addRiding(this)
  }

  public addCandidate(candidate: Candidate): void {
    this.candidatesDict[candidate.partyKey] = candidate
  }

  public name(language: string = 'en'): string {
    // Get the first part of the language code (encompasses en-ca, en-us, etc.)
    const langCode = language.split('-')[0]
    switch (langCode) {
      case 'fr':
        return this.frName
      case 'en':
      default:
        return this.enName
    }
  }

  public get key(): string {
    return `${this._id}`
  }
}
